﻿import checkoutService from '../../api/myTelia';

export default {
	name: 'my-telia-login',
	data: () => ({
		myEmail: '', 
		myPassword: '',
		postParams: []
	}),
	props: ['loginurl', 'identityserverurl'],
	methods: {
		onMyTeliaClick(event) {
			event.preventDefault();
			
			const returnUrl = location.search.split('=')[1];
			checkoutService.getLogin(this.loginurl,
				(x) => {
					let obj = JSON.parse(x);
					let params = {};

					params[obj.Data.HiddenInputs[0].Name] = obj.Data.HiddenInputs[0].Value;
					params[obj.Data.HiddenInputs[1].Name] = obj.Data.HiddenInputs[1].Value;
					params[obj.Data.HiddenInputs[2].Name] = obj.Data.HiddenInputs[2].Value;

					params.Username = this.myEmail.trim();
					params.Password = this.myPassword;
					params.RememberLogin = false;

					this.postParams = params;

					document.getElementById('checkout-form').action = obj.Data.Action;
					document.getElementById('checkout-form').noValidate = true;

					// Wait until the dom has updated before submitting the form
					this.$nextTick(() => { document.getElementById('checkout-form').submit() });
				},
				(error) => {
				});
		},
	},
};
